import { ActionSheetProvider } from "@expo/react-native-action-sheet";
import { ButtonProps, Layout } from "@ui-kitten/components";
import React, { JSXElementConstructor, ReactElement } from "react";
import { View, ViewStyle, ModalProps, Dimensions } from "react-native";
import { Modal } from "@ui-kitten/components";
import Button, { CustomizedButtonProps } from "./Button";
import Toast from "react-native-toast-message";

export interface DialogProps extends ModalProps {
  visible: boolean;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  style?: ViewStyle;
  cancelText?: ReactElement<any, string | JSXElementConstructor<any>> | string;
  onCancel?: () => void;
  cancelBtnProps?: ButtonProps;
  okText?: ReactElement<any, string | JSXElementConstructor<any>> | string;
  onOk?: (params?: any) => void;
  okBtnProps?: CustomizedButtonProps;
  animationStyle?: "none" | "slide" | "fade" | undefined;
  loading?: boolean;
  children?: any;
}
const Dialog: React.FC<DialogProps> = ({
  visible,
  setVisible = () => {},
  style,
  children,
  onOk,
  onCancel,
  okText,
  cancelText,
  okBtnProps,
  cancelBtnProps,
  loading,
}) => {
  return (
    <Modal
      visible={visible}
      style={{
        height: Dimensions.get("window").height,
        width: Dimensions.get("window").width,
      }}
    >
      <ActionSheetProvider>
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <Layout
            style={[
              {
                margin: 20,
                borderRadius: 10,
                padding: 15,
                shadowColor: "#000",
                shadowOffset: {
                  width: 0,
                  height: 2,
                },
                shadowOpacity: 0.25,
                shadowRadius: 4,
                elevation: 5,
                width: "90%",
                maxWidth: 500,
                overflow: "hidden",
              },
              style,
            ]}
          >
            {children}
            <View
              style={{
                alignSelf: "flex-end",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 10,
              }}
            >
              {cancelText ? (
                <Button
                  appearance="ghost"
                  onPress={() => {
                    onCancel ? onCancel() : setVisible && setVisible(false);
                  }}
                  {...cancelBtnProps}
                >
                  {cancelText}
                </Button>
              ) : null}
              {okText ? (
                <Button
                  appearance="ghost"
                  onPress={() => onOk && onOk()}
                  loading={loading}
                  {...okBtnProps}
                >
                  {okText}
                </Button>
              ) : null}
            </View>
          </Layout>
        </View>
      </ActionSheetProvider>
      <Toast />
    </Modal>
  );
};

export default Dialog;
